/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsModeratorControllerUpdatePriorityMutationRequest,
  UserFlagsModeratorControllerUpdatePriorityMutationResponse,
  UserFlagsModeratorControllerUpdatePriorityPathParams,
  UserFlagsModeratorControllerUpdatePriority401,
  UserFlagsModeratorControllerUpdatePriority404,
} from '../../types/UserFlagsModeratorControllerUpdatePriority.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { userFlagsModeratorUpdatePriority } from '../../methods/userFlagsModeratorUpdatePriority.ts';
import { useMutation } from '@tanstack/react-query';

export const userFlagsModeratorUpdatePriorityMutationKey = () =>
  [{ url: '/api/moderator/user-flags/priority/:id' }] as const;

export type UserFlagsModeratorUpdatePriorityMutationKey = ReturnType<
  typeof userFlagsModeratorUpdatePriorityMutationKey
>;

/**
 * {@link /api/moderator/user-flags/priority/:id}
 */
export function useUserFlagsModeratorUpdatePriority<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserFlagsModeratorControllerUpdatePriorityMutationResponse,
      ResponseErrorConfig<
        UserFlagsModeratorControllerUpdatePriority401 | UserFlagsModeratorControllerUpdatePriority404
      >,
      {
        id: UserFlagsModeratorControllerUpdatePriorityPathParams['id'];
        data: UserFlagsModeratorControllerUpdatePriorityMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<UserFlagsModeratorControllerUpdatePriorityMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? userFlagsModeratorUpdatePriorityMutationKey();

  return useMutation<
    UserFlagsModeratorControllerUpdatePriorityMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerUpdatePriority401 | UserFlagsModeratorControllerUpdatePriority404>,
    {
      id: UserFlagsModeratorControllerUpdatePriorityPathParams['id'];
      data: UserFlagsModeratorControllerUpdatePriorityMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return userFlagsModeratorUpdatePriority(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
